export const getters = {
  getModeloTanque: (state) => state.modeloTanque,
  getModelosTanques: (state) => state.modelosTanques,
  getModalCadastroModeloTanque: (state) => state.modalCadastroModeloTanque,
  getModalExcluirModeloTanque: (state) => state.modalExcluirModeloTanque,
  getModalPesquisarModeloTanque: (state) => state.modalPesquisarModeloTanque,
};

export default {};
